export default "__VITE_PUBLIC_ASSET__3aaa85fc__"